import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import { get } from '../helper/utils/try';
import { jsBridge, isCanUseH5DeviceSdkBridge } from '../plugins/useH5SdkBridge'; // import { filterConfigExtraValues } from '../helper/utils/common'

import { CONFIG_SDK_VERSION } from '../config';
/**
 * 获取H5DeviceData
 */

export var asyncGetH5DeviceData = function asyncGetH5DeviceData() {
  return new _Promise(function (resolve, reject) {
    _Promise.all([jsBridge('getBatteryInfo'), jsBridge('getContacts'), jsBridge('getSensorInfo'), jsBridge('getDeviceFingerPrint'), jsBridge('getAppList'), jsBridge('getLocation')].map(function (p) {
      return p.catch(function (e) {
        return console.log('jsBridge出错', e);
      });
    })).then(function (values) {
      resolve(values);
    }).catch(function (error) {
      reject(error.message);
    });
  });
};
/**
 * 整合H5DeviceData数据
 */

export function getH5DeviceData(_x) {
  return _getH5DeviceData.apply(this, arguments);
}

function _getH5DeviceData() {
  _getH5DeviceData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$config, config, values;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$config = _ref.config, config = _ref$config === void 0 ? {} : _ref$config;

            if (isCanUseH5DeviceSdkBridge()) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", {});

          case 3:
            _context.next = 5;
            return asyncGetH5DeviceData();

          case 5:
            values = _context.sent;
            return _context.abrupt("return", {
              battery_info: resetData(values[0], config),
              contacts: resetData(values[1], config),
              sensor_info: resetData(values[2], config),
              device_finger_print: resetAppId(values[3], config),
              app_list: resetData(values[4], config),
              location: resetData(values[5], config)
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getH5DeviceData.apply(this, arguments);
}

var resetAppId = function resetAppId(res, config) {
  var data = {
    ai: '004',
    sv: CONFIG_SDK_VERSION,
    sn: config.scenario_number || get(config, 'extra.scenario_number') || -1 // ...filterConfigExtraValues(config, true),

  };

  if (res.success) {
    data = _objectSpread(_objectSpread({}, res.data), {}, {
      app_info: _objectSpread(_objectSpread({}, res.data.app_info), {}, {
        app_id: '004'
      })
    });
  }

  return data;
};

var resetData = function resetData(res, config) {
  var data = {
    ai: '004',
    sv: CONFIG_SDK_VERSION,
    sn: config.scenario_number || get(config, 'extra.scenario_number') || -1 // ...filterConfigExtraValues(config, true),

  };

  if (res.success) {
    data = _objectSpread(_objectSpread({}, res.data), data);
  }

  return data;
};